import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { faqService, FAQItem as FAQItemType } from "services/faqService";
import { FAQContainer, FAQHeader, FAQTitle, AllViewLink, FAQList, FAQItem } from "./FAQ.styles";

export default function FAQ() {
  const [faqs, setFaqs] = useState<FAQItemType[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await faqService.getFAQs(undefined, 0, 5);
        setFaqs(data);
      } catch (error) {
        console.error("FAQ 조회 실패:", error);
      }
    };
    fetchData();
  }, []);

  const handleAllViewClick = () => {
    navigate('/faq');
  };

  const handleFAQClick = (id: number) => {
    navigate(`/faq?id=${id}`);
  };

  return (
    <FAQContainer>
      <FAQHeader>
        <FAQTitle>FAQ</FAQTitle>
        <AllViewLink onClick={handleAllViewClick}>전체보기</AllViewLink>
      </FAQHeader>
      <FAQList>
        {faqs.map((faq) => (
          <FAQItem key={faq.id} onClick={() => handleFAQClick(faq.id)}>
            • {faq.question}
          </FAQItem>
        ))}
      </FAQList>
    </FAQContainer>
  );
}
